/**
 * Cart Upsell - handles add to cart for the upsell widget in the cart drawer.
 * Uses event delegation so it works after DOM morphing.
 */
(function () {
  'use strict';

  /** @returns {string[]} */
  function getCartSectionIds() {
    const components = /** @type {NodeListOf<HTMLElement>} */ (
      document.querySelectorAll('cart-items-component[data-section-id]')
    );
    return Array.from(components)
      .map((el) => el.dataset.sectionId)
      .filter(/** @param {string|undefined} id @returns {id is string} */ (id) => Boolean(id));
  }

  /**
   * @param {string} variantId
   * @param {string[]} sectionIds
   * @returns {Promise<Record<string, unknown>>}
   */
  async function addToCart(variantId, sectionIds) {
    const payload = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionIds.join(','),
    };

    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = /** @type {Record<string, unknown>} */ (await response.json());

    if (data['status']) {
      const message = /** @type {string} */ (data['description'] || data['message'] || 'Failed to add to cart');
      throw new Error(message);
    }

    return data;
  }

  /** @param {Record<string, unknown>} data */
  function dispatchCartUpdate(data) {
    const sections = /** @type {Record<string, string> | undefined} */ (data['sections']);
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          data: {
            sections,
            source: 'cart-upsell',
          },
        },
      })
    );
  }

  /** @param {HTMLButtonElement} btn */
  function setLoading(btn) {
    const text = btn.querySelector('.cart-upsell__btn-text');
    const loading = btn.querySelector('.cart-upsell__btn-loading');
    btn.disabled = true;
    if (text instanceof HTMLElement) text.hidden = true;
    if (loading instanceof HTMLElement) loading.hidden = false;
  }

  /** @param {HTMLButtonElement} btn */
  function clearLoading(btn) {
    const text = btn.querySelector('.cart-upsell__btn-text');
    const loading = btn.querySelector('.cart-upsell__btn-loading');
    btn.disabled = false;
    if (text instanceof HTMLElement) text.hidden = false;
    if (loading instanceof HTMLElement) loading.hidden = true;
  }

  // Sync variant select → button data-variant-id
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement) || !target.matches('[data-upsell-variant-select]')) return;

    const upsell = target.closest('[data-cart-upsell]');
    const btn = upsell?.querySelector('[data-upsell-add-btn]');
    if (btn instanceof HTMLElement) {
      btn.dataset.variantId = target.value;
    }
  });

  // Add to cart on button click
  document.addEventListener('click', async (event) => {
    const btn = /** @type {HTMLElement} */ (event.target)?.closest('[data-upsell-add-btn]');
    if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const sectionIds = getCartSectionIds();

    setLoading(btn);

    try {
      const data = await addToCart(variantId, sectionIds);
      dispatchCartUpdate(data);
    } catch (error) {
      console.error('[cart-upsell]', error);
      clearLoading(btn);
    }
  });
})();
